export const mdlAuthToken = (token: string, dealersIds: (number | string)[]) =>
  '{"token":"' + token + '", "clientIds":[' + dealersIds.join(",") + "]}";
